import styled from 'styled-components'
import { Input } from 'antd'

export const AntdInput = styled(Input)`
  width: 20%;
`
